export default class GetAllTiposConvocatoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllTiposConvocatoria()
      return result
    } catch (error) {
      console.error('Error al obtener los tipos de convocatoria:', error)
      throw error
    }
  }
}
